export type GetUserGuardianDetailsSuccessResponseKeys =
  | 'user_id'
  | 'first_name'
  | 'last_name'
  | 'job_role_id'
  | 'job_role_name'
  | 'phone_number'
  | 'email';

const allSuccessKeys: GetUserGuardianDetailsSuccessResponseKeys[] = [
  'user_id',
  'first_name',
  'last_name',
  'job_role_id',
  'job_role_name',
  'phone_number',
  'email'
];

const getUserGuardianDetailsGraphQlQuery = (
  successKeys: GetUserGuardianDetailsSuccessResponseKeys[],
  withQuery = true
): string => {
  const keysToUse = successKeys?.length ? successKeys : allSuccessKeys;

  const successFields = `success_response { ${keysToUse.join(' ')} }`;

  const failureFields = `failure_response { res_status response }`;

  if (withQuery) {
    return `
    query getUserGuardianDetails{
      user_guardian_details{
        ${successFields}
        ${failureFields}
      }
    }
  `;
  } else
    return `
    user_guardian_details{
      ${successFields}
      ${failureFields}
    }
    `;
};

export { getUserGuardianDetailsGraphQlQuery };
